export const userData = [
  {
    data: [
      {
        Accuracy: 65.5,
        AccuracyHex: "#1fa088",
        AvgDiffClass: "2.0",
        AvgDiffScore: "77.87309358235622",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#feec9f",
        DiffScore: "90.24618716471244",
      },
    ],
    id: "1200003",
    password: "password",
  },
  {
    data: [
      {
        Accuracy: 93.36,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "91.36723921558101",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.62538752207112",
      },
      {
        Accuracy: 92.41,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "91.36723921558101",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.62538752207112",
      },
      {
        Accuracy: 79.71,
        AccuracyHex: "#5ec962",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "61.36723921558101",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f98e52",
        DiffScore: "71.62538752207112",
      },
      {
        Accuracy: 48.04,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "51.36723921558101",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "32.62538752207112",
      },
      {
        Accuracy: 52.82,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "55.36723921558101",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "65.62538752207112",
      },
      {
        Accuracy: 92,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "91.36723921558101",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.62538752207112",
      },
      {
        Accuracy: 91.06,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "91.36723921558101",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.62538752207112",
      },
      {
        Accuracy: 95.28,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "91.36723921558101",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.62538752207112",
      },
      {
        Accuracy: 92.41,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "91.36723921558101",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.62538752207112",
      },
      {
        Accuracy: 92.71,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "91.36723921558101",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.62538752207112",
      },
      {
        Accuracy: 93.4,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.272727272727273",
        AvgDiffScore: "91.36723921558101",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.62538752207112",
      },
    ],
    id: "1200004",
    password: "password",
  },
  {
    data: [
      {
        Accuracy: 91.14,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 94.43,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 96.06,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 83.33,
        AccuracyHex: "#5ec962",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f98e52",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 92.02,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 91.45,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 92.86,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 91.34,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 96.88,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 93.99,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 99.63,
        AccuracyHex: "#d8e219",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#c1274a",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 88.75,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.57184357025213",
      },
      {
        Accuracy: 93.16,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.230769230769231",
        AvgDiffScore: "92.13361409281838",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.57184357025213",
      },
    ],
    id: "1200012",
    password: "password",
  },
  {
    data: [
      {
        Accuracy: 86.84,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.125",
        AvgDiffScore: "91.00610359167953",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.29220718335908",
      },
      {
        Accuracy: 86.27,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.125",
        AvgDiffScore: "91.00610359167953",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.29220718335908",
      },
      {
        Accuracy: 96.86,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.125",
        AvgDiffScore: "91.00610359167953",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.29220718335908",
      },
      {
        Accuracy: 92.52,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.125",
        AvgDiffScore: "91.00610359167953",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.29220718335908",
      },
      {
        Accuracy: 77.39,
        AccuracyHex: "#3fbc73",
        AvgDiffClass: "2.125",
        AvgDiffScore: "91.00610359167953",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#fdb567",
        DiffScore: "91.29220718335908",
      },
      {
        Accuracy: 98.73,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.125",
        AvgDiffScore: "91.00610359167953",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.29220718335908",
      },
      {
        Accuracy: 88.04,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.125",
        AvgDiffScore: "91.00610359167953",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.29220718335908",
      },
      {
        Accuracy: 99.11,
        AccuracyHex: "#d8e219",
        AvgDiffClass: "2.125",
        AvgDiffScore: "91.00610359167953",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#c1274a",
        DiffScore: "91.29220718335908",
      },
    ],
    id: "1200026",
    password: "password",
  },
  {
    data: [
      {
        Accuracy: 91.68,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "1.8333333333333333",
        AvgDiffScore: "90.7657531299918",
        CompareHex: "#310597",
        DiffClassHex: "#45135c",
        DiffHex: "#f06744",
        DiffScore: "90.53983959331691",
      },
      {
        Accuracy: 96.52,
        AccuracyHex: "#addc30",
        AvgDiffClass: "1.8333333333333333",
        AvgDiffScore: "90.7657531299918",
        CompareHex: "#310597",
        DiffClassHex: "#45135c",
        DiffHex: "#dd4a4c",
        DiffScore: "90.53983959331691",
      },
      {
        Accuracy: 91.3,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "1.8333333333333333",
        AvgDiffScore: "90.7657531299918",
        CompareHex: "#310597",
        DiffClassHex: "#45135c",
        DiffHex: "#f06744",
        DiffScore: "90.53983959331691",
      },
      {
        Accuracy: 85.14,
        AccuracyHex: "#5ec962",
        AvgDiffClass: "1.8333333333333333",
        AvgDiffScore: "90.7657531299918",
        CompareHex: "#f8df25",
        DiffClassHex: "#45135c",
        DiffHex: "#f98e52",
        DiffScore: "90.53983959331691",
      },
      {
        Accuracy: 88.84,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "1.8333333333333333",
        AvgDiffScore: "90.7657531299918",
        CompareHex: "#f8df25",
        DiffClassHex: "#45135c",
        DiffHex: "#f06744",
        DiffScore: "90.53983959331691",
      },
      {
        Accuracy: 92.47,
        AccuracyHex: "#addc30",
        AvgDiffClass: "1.8333333333333333",
        AvgDiffScore: "90.7657531299918",
        CompareHex: "#310597",
        DiffClassHex: "#45135c",
        DiffHex: "#dd4a4c",
        DiffScore: "90.53983959331691",
      },
    ],
    id: "1200027",
    password: "password",
  },
  {
    data: [
      {
        Accuracy: 94.68,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.3333333333333335",
        AvgDiffScore: "93.05664733439279",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.5232946687856",
      },
      {
        Accuracy: 93.62,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.3333333333333335",
        AvgDiffScore: "93.05664733439279",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.5232946687856",
      },
      {
        Accuracy: 95.47,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.3333333333333335",
        AvgDiffScore: "93.05664733439279",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "91.5232946687856",
      },
    ],
    id: "1200035",
    password: "password",
  },
  {
    data: [
      {
        Accuracy: 88.8,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "89.23555098927795",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.12776864522256",
      },
      {
        Accuracy: 67.13,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "19.23555098927795",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "41.12776864522256",
      },
      {
        Accuracy: 57.06,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "39.23555098927795",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "61.12776864522256",
      },
      {
        Accuracy: 90.03,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "89.23555098927795",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "91.12776864522256",
      },
      {
        Accuracy: 23.48,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "59.23555098927795",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "71.12776864522256",
      },
      {
        Accuracy: 12.4,
        AccuracyHex: "#addc30",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "16.23555098927795",
        CompareHex: "#310597",
        DiffClassHex: "#d8c7be",
        DiffHex: "#dd4a4c",
        DiffScore: "51.12776864522256",
      },
      {
        Accuracy: 81.25,
        AccuracyHex: "#5ec962",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "69.23555098927795",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f98e52",
        DiffScore: "41.12776864522256",
      },
      {
        Accuracy: 77.32,
        AccuracyHex: "#84d44b",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "09.23555098927795",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f06744",
        DiffScore: "81.12776864522256",
      },
      {
        Accuracy: 80.43,
        AccuracyHex: "#5ec962",
        AvgDiffClass: "2.111111111111111",
        AvgDiffScore: "89.23555098927795",
        CompareHex: "#f8df25",
        DiffClassHex: "#d8c7be",
        DiffHex: "#f98e52",
        DiffScore: "91.12776864522256",
      },
    ],
    id: "1200042",
    password: "password",
  },
];
